<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow mt-0">
            <div class="card-header card-header-primary negative blue-grad w-50 d-flex">
              <router-link v-if="!is_bank" class="btn btn-outline-primary btn-sm mr-3"
                :to="{ name: 'contragents-search-index' }"><i class="fa fa-chevron-left mr-2"></i>{{ $t("message.back")
                }}</router-link>
              <h4 v-if="services.length > 1" class="card-title">
                {{ $t("message.find_partner.group_search") }}
              </h4>
              <h4 v-else class="card-title">
                {{ $t("message.find_partner.find_partner") }}
                <!-- {{$t('message.find_partner.common_info_cn')}} -->
              </h4>
              <!-- <router-link v-if="is_bank" class="btn btn-outline-primary btn-sm ml-2" :to="{name: 'cn-search-history-note'}"><i class="fa fa-history mr-2"></i>{{$t('message.history')}}</router-link> -->
            </div>
            <div class="card-body">
              <b-tabs pills content-class="mt-3" small v-model="current_tab">
                <b-tab :title="$t('message.find_partner.search_button')" active id="search-tab">
                  <div v-if="showKeyWord" class="row-">
                    <div class="col-md-6-">
                      <span :class="['form-group']">
                        <div class="d-flex align-items-center dedede">
                          <div class="icon">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M13.6041 12.4159L18.0875 16.8993C18.2451 17.057 18.3335 17.2708 18.3335 17.4937C18.3334 17.7167 18.2447 17.9304 18.0871 18.088C17.9294 18.2456 17.7155 18.3341 17.4926 18.334C17.2697 18.3339 17.0559 18.2453 16.8983 18.0876L12.415 13.6043C11.0747 14.6423 9.38937 15.1308 7.70174 14.9704C6.01412 14.81 4.451 14.0126 3.33037 12.7406C2.20975 11.4686 1.61579 9.81746 1.66935 8.12307C1.7229 6.42868 2.41993 4.81833 3.61864 3.61962C4.81735 2.4209 6.4277 1.72387 8.12209 1.67032C9.81648 1.61677 11.4676 2.21072 12.7396 3.33135C14.0117 4.45197 14.809 6.01509 14.9694 7.70272C15.1299 9.39034 14.6414 11.0757 13.6033 12.4159H13.6041ZM8.3333 13.3334C9.65938 13.3334 10.9312 12.8067 11.8688 11.869C12.8065 10.9313 13.3333 9.65953 13.3333 8.33345C13.3333 7.00736 12.8065 5.73559 11.8688 4.79791C10.9312 3.86023 9.65938 3.33345 8.3333 3.33345C7.00722 3.33345 5.73545 3.86023 4.79777 4.79791C3.86009 5.73559 3.3333 7.00736 3.3333 8.33345C3.3333 9.65953 3.86009 10.9313 4.79777 11.869C5.73545 12.8067 7.00722 13.3334 8.3333 13.3334Z"
                                fill="#8D8D8D" />
                            </svg>
                          </div>
                          <translatableField @updateTranslation="keyWord = $event">
                            <input type="text" class="form-control" id="keyword" v-model="keyWord" :placeholder="$t(
                              'message.find_partner.bn_search_keyword_placeholder',
                            )
                              " autocomplete="off" style="cursor: auto" />
                          </translatableField>
                          <button :class="[
                            'btn',
                            'btn-success',
                            'btn-round',
                            'btn-sm',
                            'position-relative',
                          ]" @click="searchServices" id="init_search_china">
                            {{ $t("message.find_partner.search_button") }}
                          </button>
                        </div>
                      </span>
                    </div>
                  </div>

                  <div v-if="loading > 0" style="position: relative; padding-bottom: 20px">
                    <!-- <div class="loading"></div> -->
                    <!-- <div class="text-center"> {{$t('message.find_partner.load_in_progress')}}</div> -->

                    <div class="row">
                      <div class="col-md-2"></div>
                      <div class="col-md-8">
                        <b-progress :value="total_loaded" :max="services.length * 3 + 1" show-progress
                          animated></b-progress>
                      </div>
                    </div>
                    <div class="text-center">
                      {{ timer_minutes }}:{{ timer_seconds }}
                    </div>
                    <div class="text-center" v-if="locale == 'ru' && total_loaded == 1">
                      {{
                        $t(
                          "message.find_partner.services_parameter_translation",
                        )
                      }}
                    </div>
                    <div v-for="(srvc, i) in services_loading">
                      <div class="text-center">
                        {{ $t("message.find_partner.service_" + srvc.service) }}
                        {{ $t("message.find_partner.services_loading") }}
                      </div>
                      <div class="text-center" v-if="srvc.loading_step == 1">
                        {{ $t("message.find_partner.services_loading_data") }}
                      </div>
                      <div class="text-center" v-if="srvc.loading_step == 2">
                        {{
                          $t(
                            "message.find_partner.services_loading_translations",
                          )
                        }}
                      </div>
                      <div class="text-center" v-if="srvc.loading_step == 3">
                        {{ $t("message.find_partner.services_rendering") }}
                      </div>
                    </div>
                  </div>
                  <div v-if="loading == 0" class="py-5 d-flex">
                    <div class="d-flex ml-auto" style="gap: 10px">
                      <pdf v-if="loading == 0" :user_id="0" :document="pdf_document" :doc_additional="pdf_parameters"
                        :goods="services" :doc_id="0" source="main-service-cn"></pdf>
                      <button v-if="loading == 0" @click.prevent="sendToAnalyze" :disabled="history_record_id == false"
                        class="btn btn-sm btn-outline-secondary">
                        <span v-if="!sia_loading">{{
                          $t("message.analyze")
                        }}</span>
                        <span v-else>{{ $t("message.find_partner.services_loading") }}...
                          {{ sia_time }}</span>
                      </button>
                    </div>
                  </div>
                  <div class="px-4">
                    <enterprise-fuzzy-service-cn v-if="enterprise_fuzzy_complete && loading == 0"
                      :data="business_fuzzy_info" :progress="progress_fuzzy"></enterprise-fuzzy-service-cn>
                    <tmp-company-info-service-cn v-if="search_company_info_complete && loading == 0"
                      :data="company_info_data"></tmp-company-info-service-cn>
                    <tmp-court-info-service-cn v-if="court_search_complete && loading == 0"
                      :data="court_info_data"></tmp-court-info-service-cn>
                    <tmp-company-news-service-cn v-if="news_search_complete && loading == 0"
                      :data="news_info_data"></tmp-company-news-service-cn>
                    <tmp-risk-scan-cn v-if="risk_search_complete && loading == 0"
                      :data="risk_info_data"></tmp-risk-scan-cn>
                    <tmp-annual-report-service-cn v-if="anual_search_complete && loading == 0"
                      :data="annual_info_data"></tmp-annual-report-service-cn>
                  </div>

                  <div v-if="loading == 0 && services.length === no_result" class="mt-3 text-center pb-3 alert"
                    id="no-results-doc">
                    <!-- {{noResultsLabel()}} -->
                    <div class="card">
                      <div class="card-body">
                        <div class="position-relative">
                          <h2 class="text-center">
                            Attis {{ $t("message.find_partner.find_partner") }}
                          </h2>
                          <button class="btn btn-outline-primary position-absolute" style="right: 0; top: 0"
                            @click="makePdf">
                            {{ $t("message.find_partner.download_pdf") }}
                          </button>
                        </div>
                        <h4 class="text-center">
                          {{ $t("message.find_partner.search_certificate") }}
                        </h4>
                        <div class="text-left">
                          {{ $t("message.find_partner.search_query") }}:
                          {{ keyWord }}
                          <!-- {{ no_results_report.content.data.search_term }} -->
                        </div>
                        <div class="text-left">
                          {{ $t("message.find_partner.request_from") }}:
                          {{ user_full_name }}
                        </div>
                        <div class="text-left">
                          {{ $t("message.find_partner.request_date") }}:
                          {{ momentum_now() }}
                          <!-- {{ no_results_report.content.data.created_at }} -->
                        </div>
                        <!-- <div class="text-left">
                                                        Нечеткость: 
                                                        {{ no_results_report.content.data.filters.fuzziness }}%
                                                    </div> -->
                        <!-- <div>
                                                        Типы: <span class="badge border-primary border text-primary mr-2 mb-2" v-for="type in no_results_report.content.data.filters.types">{{ type }}</span>
                                                    </div> -->
                        <div class="text-left">
                          {{ $t("message.find_partner.no_matches_line") }}
                        </div>
                        <!-- <div>
                                                        Уровень риска: {{ no_results_report.content.data.risk_level }}
                                                    </div> -->
                        <h4 class="mt-3 text-left">
                          {{ $t("message.find_partner.search_results") }}
                        </h4>
                        <div class="text-left" style="
                            border: 1px solid #ccc;
                            padding: 15px;
                            border-radius: 5px;
                          ">
                          {{ $t("message.find_partner.found_matches") }}:
                          <span class="badge bg-primary"> 0 </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row d-none">
                    <div class="col-12">
                      <div class="p-5">
                        <div class="mb-3">
                          {{ $t("message.find_partner.info_1")
                          }}{{ $t("message.find_partner.info_1_more") }}
                        </div>
                        <div class="d-flex flex-wrap services-list">
                          <div class="service-block">
                            <h4>Поиск компаний</h4>
                            <p>
                              Получите список компаний, соответствующих
                              критериям поиска, путем поиска по ключевым словам
                              (таким как название компании, имя человека,
                              название продукта, адрес, номер телефона, сфера
                              деятельности и т. д.) Дата, единый код социального
                              кредита, регистрационный номер и другую
                              информацию.
                            </p>
                          </div>
                          <div class="service-block">
                            <h4>Информация о компании</h4>
                            <p>
                              Запрос предоставляет полную информацию о бизнесе,
                              такую ​​как название компании, статус регистрации,
                              уставный капитал, единый код социального кредита,
                              тип бизнеса, срок работы, численность персонала,
                              юридический адрес, сферу деятельности и другую
                              информацию. В то же время он предоставляет данные,
                              связанные с предприятием, такие
                              как:зарегистрированные акционеры, ключевой
                              персонал, иностранные инвестиции компании, записи
                              об изменениях, управляющие компании, филиалы,
                              головные офисы, контактные телефоны, контактные
                              адреса электронной почты и другую информацию.
                              Позвольте вам получить всю информацию о
                              предприятии одним запросом.
                            </p>
                          </div>
                          <div class="service-block">
                            <h4>Проверка судебных решений</h4>
                            <p>
                              Получите исторические данные судебных дел
                              запрашиваемой компании, выполнив поиск по ключевым
                              словам, и верните исторический номер дела, тип
                              процесса, лицо, ведшее процесс, истец, ответчик и
                              другую информацию.
                            </p>
                          </div>
                          <div class="service-block">
                            <h4>Поиск корпоративных новостей</h4>
                            <p>
                              Описание: Получите новости компании общественное
                              мнение, а с помощью интеллектуального анализа
                              данных Qichacha определите эмоциональный тип
                              новостей и верните поля, такие как заголовок,
                              источник и категория новостей.
                            </p>
                          </div>
                          <div class="service-block">
                            <h4>Годовой отчет</h4>
                            <p>
                              Описание: годовой отчет компании включает в себя
                              основную информацию, заявленную самой компанией,
                              информацию о веб-сайте или интернет-магазине,
                              информацию о спонсорах и вкладах в капитал,
                              информацию о состоянии корпоративных активов и
                              изменениях в капитале и т. д.
                            </p>
                          </div>
                          <div class="service-block">
                            <h4>Корпоративные риски</h4>
                            <p>
                              Описание: Текущий интерфейс включает в себя как
                              деловую информацию (включая деловые интервью,
                              информацию об акционерах (включая соотношение
                              долей), ключевой персонал, филиалы, информацию об
                              изменениях, отраслевую классификацию,
                              корпоративные портреты и т. д.), так и информацию
                              о корпоративных рисках, такую как как
                              административное дела, неправомерные хозяйственные
                              операции, недобросовестные лица, подлежащие
                              ответственности, лица, подлежащие наказанию,
                              ипотека движимого имущества, ликвидация, залог
                              акций, выборочная проверка, налоговый кредит и
                              другая информация. Комплексный запрос измерения
                              позволяет получить всю информацию о предприятии в
                              одном запросе.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab :title="$t('message.find_partner.history')" lazy id="case-management-tab">
                  <CNSearchHistory />
                </b-tab>
              </b-tabs>
            </div>
          </div>

          <div class="card no-shadow">
            <div class="card-header">
              <div class="d-flex gap-10">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12 4C9.25791 4 7 6.275 7 9.125C7 11.028 7.67993 12.0566 8.90618 13.8235C9.4245 14.557 9.7064 15.2055 9.85313 15.7645C9.87446 15.8458 9.89269 15.9243 9.90828 16H9.91096H9.91725H9.92355H9.92985H9.93616H9.94247H9.94878H9.9551H9.96142H9.96774H9.97407H9.9804H9.98673H9.99307H9.99941H10.0058H10.0121H10.0185H10.0248H10.0312H10.0375H10.0439H10.0502H10.0566H10.063H10.0694H10.0757H10.0821H10.0885H10.0949H10.1013H10.1077H10.114H10.1204H10.1268H10.1332H10.1396H10.146H10.1524H10.1588H10.1652H10.1716H10.1781H10.1845H10.1909H10.1973H10.2037H10.2101H10.2166H10.223H10.2294H10.2358H10.2423H10.2487H10.2551H10.2615H10.268H10.2744H10.2808H10.2873H10.2937H10.3001H10.3066H10.313H10.3194H10.3259H10.3323H10.3388H10.3452H10.3516H10.3581H10.3645H10.371H10.3774H10.3838H10.3903H10.3967H10.4032H10.4096H10.416H10.4225H10.4289H10.4354H10.4418H10.4482H10.4547H10.4611H10.4676H10.474H10.4804H10.4869H10.4933H10.4997H10.5062H10.5126H10.519H10.5255H10.5319H10.5383H10.5447H10.5512H10.5576H10.564H10.5704H10.5769H10.5833H10.5897H10.5961H10.6025H10.6089H10.6153H10.6218H10.6282H10.6346H10.641H10.6474H10.6538H10.6602H10.6666H10.673H10.6793H10.6857H10.6921H10.6985H10.7049H10.7113H10.7176H10.724H10.7304H10.7367H10.7431H10.7495H10.7558H10.7622H10.7685H10.7749H10.7812H10.7876H10.7939H10.8003H10.8066H10.8129H10.8193H10.8256H10.8319H10.8382H10.8445H10.8508H10.8571H10.8635H10.8697H10.876H10.8823H10.8886H10.8949H10.9012H10.9075H10.9137H10.92H10.9263H10.9325H10.9388H10.945H10.9513H10.9575H10.9637H10.97H10.9762H10.9824H10.9886H10.9948H11.001H11.0072H11.0134H11.0196H11.0258H11.032H11.0382H11.0443H11.0505H11.0567H11.0628H11.069H11.0751H11.0812H11.0874H11.0935H11.0996H11.1057H11.1118H11.118H11.124H11.1301H11.1362H11.1423H11.1484H11.1544H11.1605H11.1666H11.1726H11.1786H11.1847H11.1907H11.1967H11.2027H11.2088H11.2148H11.2207H11.2267H11.2327H11.2387H11.2447H11.2506H11.2566H11.2625H11.2685H11.2744H11.2803H11.2862H11.2921H11.298H11.3039H11.3098H11.3157H11.3216H11.3274H11.3333H11.3391H11.345H11.3508H11.3566H11.3624H11.3683H11.3741H11.3798H11.3856H11.3914H11.3972H11.4029H11.4087H11.4144H11.4201H11.4259H11.4316H11.4373H11.443H11.4487H11.4544H11.46H11.4657H11.4714H11.477H11.4826H11.4883H11.4939H11.4995H11.5051H11.5107H11.5162H11.5218H11.5274H11.5329H11.5385H11.544H11.5495H11.555H11.5605H11.566H11.5715H11.577H11.5824H11.5879H11.5933H11.5988H11.6042H11.6096H11.615H11.6204H11.6258H11.6311H11.6365H11.6418H11.6472H11.6525H11.6578H11.6631H11.6684H11.6737H11.679H11.6842H11.6895H11.6947H11.7H11.7052H11.7104H11.7156H11.7208H11.7259H11.7311H11.7362H11.7414H11.7465H11.7516H11.7567H11.7618H11.7669H11.7719H11.777H11.782H11.7871H11.7921H11.7971H11.8021H11.8071H11.812H11.817H11.8219H11.8268H11.8318H11.8367H11.8416H11.8464H11.8513H11.8562H11.861H11.8658H11.8706H11.8755H11.8802H11.885H11.8898H11.8945H11.8993H11.904H11.9087H11.9134H11.9181H11.9227H11.9274H11.932H11.9367H11.9413H11.9459H11.9505H11.955H11.9596H11.9642H11.9687H11.9732H11.9777H11.9822H11.9867H11.9911H11.9956H12H12.0044H12.0089H12.0133H12.0178H12.0223H12.0268H12.0313H12.0358H12.0404H12.045H12.0495H12.0541H12.0587H12.0633H12.068H12.0726H12.0773H12.0819H12.0866H12.0913H12.096H12.1007H12.1055H12.1102H12.115H12.1198H12.1245H12.1294H12.1342H12.139H12.1438H12.1487H12.1536H12.1584H12.1633H12.1682H12.1732H12.1781H12.183H12.188H12.1929H12.1979H12.2029H12.2079H12.2129H12.218H12.223H12.2281H12.2331H12.2382H12.2433H12.2484H12.2535H12.2586H12.2638H12.2689H12.2741H12.2792H12.2844H12.2896H12.2948H12.3H12.3053H12.3105H12.3158H12.321H12.3263H12.3316H12.3369H12.3422H12.3475H12.3528H12.3582H12.3635H12.3689H12.3742H12.3796H12.385H12.3904H12.3958H12.4012H12.4067H12.4121H12.4176H12.423H12.4285H12.434H12.4395H12.445H12.4505H12.456H12.4615H12.4671H12.4726H12.4782H12.4838H12.4893H12.4949H12.5005H12.5061H12.5117H12.5174H12.523H12.5286H12.5343H12.54H12.5456H12.5513H12.557H12.5627H12.5684H12.5741H12.5799H12.5856H12.5913H12.5971H12.6028H12.6086H12.6144H12.6202H12.6259H12.6317H12.6376H12.6434H12.6492H12.655H12.6609H12.6667H12.6726H12.6784H12.6843H12.6902H12.6961H12.702H12.7079H12.7138H12.7197H12.7256H12.7315H12.7375H12.7434H12.7494H12.7553H12.7613H12.7673H12.7733H12.7793H12.7852H12.7912H12.7973H12.8033H12.8093H12.8153H12.8214H12.8274H12.8334H12.8395H12.8456H12.8516H12.8577H12.8638H12.8699H12.876H12.882H12.8882H12.8943H12.9004H12.9065H12.9126H12.9188H12.9249H12.931H12.9372H12.9433H12.9495H12.9557H12.9618H12.968H12.9742H12.9804H12.9866H12.9928H12.999H13.0052H13.0114H13.0176H13.0238H13.03H13.0363H13.0425H13.0487H13.055H13.0612H13.0675H13.0737H13.08H13.0863H13.0925H13.0988H13.1051H13.1114H13.1177H13.124H13.1303H13.1365H13.1429H13.1492H13.1555H13.1618H13.1681H13.1744H13.1807H13.1871H13.1934H13.1997H13.2061H13.2124H13.2188H13.2251H13.2315H13.2378H13.2442H13.2505H13.2569H13.2633H13.2696H13.276H13.2824H13.2887H13.2951H13.3015H13.3079H13.3143H13.3207H13.327H13.3334H13.3398H13.3462H13.3526H13.359H13.3654H13.3718H13.3782H13.3847H13.3911H13.3975H13.4039H13.4103H13.4167H13.4231H13.4296H13.436H13.4424H13.4488H13.4553H13.4617H13.4681H13.4745H13.481H13.4874H13.4938H13.5003H13.5067H13.5131H13.5196H13.526H13.5324H13.5389H13.5453H13.5518H13.5582H13.5646H13.5711H13.5775H13.584H13.5904H13.5968H13.6033H13.6097H13.6162H13.6226H13.629H13.6355H13.6419H13.6484H13.6548H13.6612H13.6677H13.6741H13.6806H13.687H13.6934H13.6999H13.7063H13.7127H13.7192H13.7256H13.732H13.7385H13.7449H13.7513H13.7577H13.7642H13.7706H13.777H13.7834H13.7899H13.7963H13.8027H13.8091H13.8155H13.8219H13.8284H13.8348H13.8412H13.8476H13.854H13.8604H13.8668H13.8732H13.8796H13.886H13.8923H13.8987H13.9051H13.9115H13.9179H13.9243H13.9306H13.937H13.9434H13.9498H13.9561H13.9625H13.9688H13.9752H13.9815H13.9879H13.9942H14.0006H14.0069H14.0133H14.0196H14.0259H14.0323H14.0386H14.0449H14.0512H14.0575H14.0638H14.0701H14.0764H14.0827H14.089H14.0917C14.1073 15.9243 14.1255 15.8458 14.1469 15.7645C14.2936 15.2055 14.5755 14.557 15.0938 13.8235C16.3201 12.0566 17 11.0281 17 9.125C17 6.275 14.7421 4 12 4ZM16 18V17C16 16.8023 16.0009 16.5789 16.0813 16.2723C16.1626 15.9628 16.3364 15.5301 16.7292 14.9749L16.7292 14.9749L16.7344 14.9675L16.7412 14.9576C17.9704 13.1865 19 11.703 19 9.125C19 5.20951 15.8853 2 12 2C8.11467 2 5 5.20951 5 9.125C5 11.703 6.0296 13.1865 7.25881 14.9576L7.26564 14.9675L7.26561 14.9675L7.27083 14.9749C7.66363 15.5301 7.83744 15.9628 7.91866 16.2723C7.99914 16.5789 8 16.8023 8 17V18V19C8 20.6569 9.34315 22 11 22H13C14.6569 22 16 20.6569 16 19V18ZM10 19V18H10.0058H10.0121H10.0185H10.0248H10.0312H10.0375H10.0439H10.0502H10.0566H10.063H10.0694H10.0757H10.0821H10.0885H10.0949H10.1013H10.1077H10.114H10.1204H10.1268H10.1332H10.1396H10.146H10.1524H10.1588H10.1652H10.1716H10.1781H10.1845H10.1909H10.1973H10.2037H10.2101H10.2166H10.223H10.2294H10.2358H10.2423H10.2487H10.2551H10.2615H10.268H10.2744H10.2808H10.2873H10.2937H10.3001H10.3066H10.313H10.3194H10.3259H10.3323H10.3388H10.3452H10.3516H10.3581H10.3645H10.371H10.3774H10.3838H10.3903H10.3967H10.4032H10.4096H10.416H10.4225H10.4289H10.4354H10.4418H10.4482H10.4547H10.4611H10.4676H10.474H10.4804H10.4869H10.4933H10.4997H10.5062H10.5126H10.519H10.5255H10.5319H10.5383H10.5447H10.5512H10.5576H10.564H10.5704H10.5769H10.5833H10.5897H10.5961H10.6025H10.6089H10.6153H10.6218H10.6282H10.6346H10.641H10.6474H10.6538H10.6602H10.6666H10.673H10.6793H10.6857H10.6921H10.6985H10.7049H10.7113H10.7176H10.724H10.7304H10.7367H10.7431H10.7495H10.7558H10.7622H10.7685H10.7749H10.7812H10.7876H10.7939H10.8003H10.8066H10.8129H10.8193H10.8256H10.8319H10.8382H10.8445H10.8508H10.8571H10.8635H10.8697H10.876H10.8823H10.8886H10.8949H10.9012H10.9075H10.9137H10.92H10.9263H10.9325H10.9388H10.945H10.9513H10.9575H10.9637H10.97H10.9762H10.9824H10.9886H10.9948H11.001H11.0072H11.0134H11.0196H11.0258H11.032H11.0382H11.0443H11.0505H11.0567H11.0628H11.069H11.0751H11.0812H11.0874H11.0935H11.0996H11.1057H11.1118H11.118H11.124H11.1301H11.1362H11.1423H11.1484H11.1544H11.1605H11.1666H11.1726H11.1786H11.1847H11.1907H11.1967H11.2027H11.2088H11.2148H11.2207H11.2267H11.2327H11.2387H11.2447H11.2506H11.2566H11.2625H11.2685H11.2744H11.2803H11.2862H11.2921H11.298H11.3039H11.3098H11.3157H11.3216H11.3274H11.3333H11.3391H11.345H11.3508H11.3566H11.3624H11.3683H11.3741H11.3798H11.3856H11.3914H11.3972H11.4029H11.4087H11.4144H11.4201H11.4259H11.4316H11.4373H11.443H11.4487H11.4544H11.46H11.4657H11.4714H11.477H11.4826H11.4883H11.4939H11.4995H11.5051H11.5107H11.5162H11.5218H11.5274H11.5329H11.5385H11.544H11.5495H11.555H11.5605H11.566H11.5715H11.577H11.5824H11.5879H11.5933H11.5988H11.6042H11.6096H11.615H11.6204H11.6258H11.6311H11.6365H11.6418H11.6472H11.6525H11.6578H11.6631H11.6684H11.6737H11.679H11.6842H11.6895H11.6947H11.7H11.7052H11.7104H11.7156H11.7208H11.7259H11.7311H11.7362H11.7414H11.7465H11.7516H11.7567H11.7618H11.7669H11.7719H11.777H11.782H11.7871H11.7921H11.7971H11.8021H11.8071H11.812H11.817H11.8219H11.8268H11.8318H11.8367H11.8416H11.8464H11.8513H11.8562H11.861H11.8658H11.8706H11.8755H11.8802H11.885H11.8898H11.8945H11.8993H11.904H11.9087H11.9134H11.9181H11.9227H11.9274H11.932H11.9367H11.9413H11.9459H11.9505H11.955H11.9596H11.9642H11.9687H11.9732H11.9777H11.9822H11.9867H11.9911H11.9956H12H12.0044H12.0089H12.0133H12.0178H12.0223H12.0268H12.0313H12.0358H12.0404H12.045H12.0495H12.0541H12.0587H12.0633H12.068H12.0726H12.0773H12.0819H12.0866H12.0913H12.096H12.1007H12.1055H12.1102H12.115H12.1198H12.1245H12.1294H12.1342H12.139H12.1438H12.1487H12.1536H12.1584H12.1633H12.1682H12.1732H12.1781H12.183H12.188H12.1929H12.1979H12.2029H12.2079H12.2129H12.218H12.223H12.2281H12.2331H12.2382H12.2433H12.2484H12.2535H12.2586H12.2638H12.2689H12.2741H12.2792H12.2844H12.2896H12.2948H12.3H12.3053H12.3105H12.3158H12.321H12.3263H12.3316H12.3369H12.3422H12.3475H12.3528H12.3582H12.3635H12.3689H12.3742H12.3796H12.385H12.3904H12.3958H12.4012H12.4067H12.4121H12.4176H12.423H12.4285H12.434H12.4395H12.445H12.4505H12.456H12.4615H12.4671H12.4726H12.4782H12.4838H12.4893H12.4949H12.5005H12.5061H12.5117H12.5174H12.523H12.5286H12.5343H12.54H12.5456H12.5513H12.557H12.5627H12.5684H12.5741H12.5799H12.5856H12.5913H12.5971H12.6028H12.6086H12.6144H12.6202H12.6259H12.6317H12.6376H12.6434H12.6492H12.655H12.6609H12.6667H12.6726H12.6784H12.6843H12.6902H12.6961H12.702H12.7079H12.7138H12.7197H12.7256H12.7315H12.7375H12.7434H12.7494H12.7553H12.7613H12.7673H12.7733H12.7793H12.7852H12.7912H12.7973H12.8033H12.8093H12.8153H12.8214H12.8274H12.8334H12.8395H12.8456H12.8516H12.8577H12.8638H12.8699H12.876H12.882H12.8882H12.8943H12.9004H12.9065H12.9126H12.9188H12.9249H12.931H12.9372H12.9433H12.9495H12.9557H12.9618H12.968H12.9742H12.9804H12.9866H12.9928H12.999H13.0052H13.0114H13.0176H13.0238H13.03H13.0363H13.0425H13.0487H13.055H13.0612H13.0675H13.0737H13.08H13.0863H13.0925H13.0988H13.1051H13.1114H13.1177H13.124H13.1303H13.1365H13.1429H13.1492H13.1555H13.1618H13.1681H13.1744H13.1807H13.1871H13.1934H13.1997H13.2061H13.2124H13.2188H13.2251H13.2315H13.2378H13.2442H13.2505H13.2569H13.2633H13.2696H13.276H13.2824H13.2887H13.2951H13.3015H13.3079H13.3143H13.3207H13.327H13.3334H13.3398H13.3462H13.3526H13.359H13.3654H13.3718H13.3782H13.3847H13.3911H13.3975H13.4039H13.4103H13.4167H13.4231H13.4296H13.436H13.4424H13.4488H13.4553H13.4617H13.4681H13.4745H13.481H13.4874H13.4938H13.5003H13.5067H13.5131H13.5196H13.526H13.5324H13.5389H13.5453H13.5518H13.5582H13.5646H13.5711H13.5775H13.584H13.5904H13.5968H13.6033H13.6097H13.6162H13.6226H13.629H13.6355H13.6419H13.6484H13.6548H13.6612H13.6677H13.6741H13.6806H13.687H13.6934H13.6999H13.7063H13.7127H13.7192H13.7256H13.732H13.7385H13.7449H13.7513H13.7577H13.7642H13.7706H13.777H13.7834H13.7899H13.7963H13.8027H13.8091H13.8155H13.8219H13.8284H13.8348H13.8412H13.8476H13.854H13.8604H13.8668H13.8732H13.8796H13.886H13.8923H13.8987H13.9051H13.9115H13.9179H13.9243H13.9306H13.937H13.9434H13.9498H13.9561H13.9625H13.9688H13.9752H13.9815H13.9879H13.9942H14V19C14 19.5523 13.5523 20 13 20H11C10.4477 20 10 19.5523 10 19ZM10.7808 8C9.47963 8 8.52492 9.22278 8.84049 10.4851L9.02986 11.2425C9.16381 11.7783 9.70674 12.1041 10.2425 11.9701C10.7783 11.8362 11.1041 11.2933 10.9701 10.7575L10.7808 10L13.2192 10L13.0299 10.7575C12.8959 11.2933 13.2217 11.8362 13.7575 11.9701C14.2933 12.1041 14.8362 11.7783 14.9701 11.2425L15.1595 10.4851C15.4751 9.22278 14.5204 8 13.2192 8H10.7808Z"
                    fill="#FE5000" />
                </svg>
                <div>Как получить бизнес справку</div>
              </div>
            </div>
            <div class="card-body">
              <div class="da-list">
                <div class="item">
                  Для поиска Вам необходимо ввести Единый социальный кредитный
                  код или Регистрационный номер контрагента.
                </div>
                <div class="item">
                  Все результаты поиска сохраняются в истории. Вы можете
                  получить доступ к сохраненным результатам, как для повторного
                  просмотра, так и для вывода на печать
                </div>
              </div>
            </div>
          </div>
          <div class="card no-shadow">
            <div class="card-header">
              <div class="d-flex gap-10">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12C11 11.4477 11.4477 11 12 11ZM12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9H12.01C12.5623 9 13.01 8.55228 13.01 8C13.01 7.44772 12.5623 7 12.01 7H12Z"
                    fill="#FE5000" />
                </svg>
                <div>Описание услуги</div>
              </div>
            </div>
            <div class="card-body">
              <p>Получение подробной информации по выбранному контрагенту:</p>
              <ul>
                <li>
                  Основная информация о компании: содержит деловую и отраслевую
                  информацию о предприятии, такую ​​как название предприятия,
                  статус регистрации, уставный капитал, единый код социального
                  кредита, тип предприятия, период деятельности, численность
                  персонала, юридический адрес, сфера деятельности, промышленные
                  и коммерческие зарегистрированные акционеры, ключевой персонал
                  в промышленной и коммерческой регистрации, иностранные
                  инвестиции компании, записи об изменениях, управляющие
                  компании, филиалы, головные офисы, контактные телефоны,
                  контактные адреса электронной почты и другую информацию.
                  Позвольте вам получить всю информацию о предприятии только с
                  одним запросом.
                </li>
                <li>
                  Информация о корпоративном годовом отчете: годовой отчет
                  компании включает в себя основную информацию, заявленную самой
                  компанией, информацию о веб-сайте или интернет-магазине,
                  информацию о спонсорах и вкладах в капитал, информацию о
                  состоянии корпоративных активов и изменениях в капитале и т.
                  д.
                </li>
                <li>
                  Сканирование корпоративных рисков: деловая информация (включая
                  деловые интервью, информацию об акционерах (включая
                  соотношение долей), ключевой персонал, филиалы, информацию об
                  изменениях, отраслевую классификацию, корпоративные портреты и
                  т. д.). Информация, связанная с корпоративными рисками, такие
                  как административное наказание, неправомерные деловые
                  операции, недобросовестные лица, подлежащие исполнению, лица,
                  подлежащие исполнению, ипотека движимого имущества,
                  ликвидация, залог акций, выборочная проверка, налоговый кредит
                  и другая информация.
                </li>
                <li>
                  Подтверждение наличия судебных уведомления: данные о судебных
                  объявлениях по запрашиваемому контрагенту
                </li>
                <li>
                  Новости и общественное мнение: новости о контрагенте с помощью
                  интеллектуального анализа данных Qichacha из открытых
                  источников информации в КНР.
                </li>
              </ul>
            </div>
          </div>
          <div class="row columns">
            <div class="col-md-4">
              <div class="card no-shadow">
                <div class="card-header">
                  <div class="icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M7 4H17C17.5523 4 18 4.44772 18 5V19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19V5C6 4.44772 6.44771 4 7 4ZM4 5C4 3.34315 5.34315 2 7 2H17C18.6569 2 20 3.34315 20 5V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V5ZM9 6C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8H15C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6H9ZM8 11C8 10.4477 8.44772 10 9 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H9C8.44772 12 8 11.5523 8 11ZM9 14C8.44772 14 8 14.4477 8 15C8 15.5523 8.44772 16 9 16H11.5C12.0523 16 12.5 15.5523 12.5 15C12.5 14.4477 12.0523 14 11.5 14H9Z"
                        fill="#FE5000" />
                    </svg>
                  </div>
                  <div class="title">Поиск по реквизитам контрагента</div>
                </div>
                <div class="card-body">
                  <p>
                    Система предоставляет выборку компаний в КНР по названию
                    компании (или частичному наименованию).
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card no-shadow">
                <div class="card-header">
                  <div class="icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M4.00025 7V13H12.0003H20.0003V7H12.0003H4.00025ZM12.0003 7C10.3434 7 9.00025 8.34315 9.00025 10C9.00025 11.6569 10.3434 13 12.0003 13C13.6571 13 15.0003 11.6569 15.0003 10C15.0003 8.34315 13.6571 7 12.0003 7ZM3.00025 5C2.44797 5 2.00025 5.44772 2.00025 6V13.977C1.99564 14.1808 2.05387 14.3805 2.16422 14.5489C2.27487 14.7171 2.43492 14.8499 2.62373 14.9267L17.6026 21.4176C17.8599 21.529 18.1521 21.5274 18.4081 21.4131C18.6641 21.2987 18.8603 21.0822 18.9489 20.8162L20.8877 15H21.0003C21.5525 15 22.0003 14.5523 22.0003 14V6C22.0003 5.44772 21.5525 5 21.0003 5H3.00025ZM17.3966 19.1486L7.82299 15H18.7795L17.3966 19.1486ZM13.0003 10C13.0003 10.5523 12.5525 11 12.0003 11C11.448 11 11.0003 10.5523 11.0003 10C11.0003 9.44772 11.448 9 12.0003 9C12.5525 9 13.0003 9.44772 13.0003 10Z"
                        fill="#FE5000" />
                    </svg>
                  </div>
                  <div class="title">
                    Автоматическая тарификация с&nbsp;контролем достаточности
                  </div>
                </div>
                <div class="card-body">
                  <p>
                    Сервис производит автоматическую тарификацию предоставления
                    результатов, с контролем достаточности денежных средств на
                    Вашем системном счете.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card no-shadow">
                <div class="card-header">
                  <div class="icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10.2865 2C7.5251 2 5.28653 4.23858 5.28653 7V9.32908C5.28653 10.6989 5.052 12.0586 4.5931 13.3492L3.53327 16.33C3.07033 17.632 4.03582 19 5.4177 19H8.00073C8.00073 20.6569 9.34388 22 11.0007 22H13.0007C14.6576 22 16.0007 20.6569 16.0007 19H18.5839C19.9658 19 20.9313 17.632 20.4684 16.33L19.4085 13.3492C18.9496 12.0586 18.7151 10.6989 18.7151 9.32908V7C18.7151 4.23858 16.4765 2 13.7151 2H10.2865ZM14.0007 19H10.0007C10.0007 19.5523 10.4484 20 11.0007 20H13.0007C13.553 20 14.0007 19.5523 14.0007 19ZM16.0007 17H18.5839L17.5241 14.0192C16.9887 12.5135 16.7151 10.9272 16.7151 9.32908V7C16.7151 5.34315 15.372 4 13.7151 4H10.2865C8.62967 4 7.28653 5.34315 7.28653 7V9.32908C7.28653 10.9272 7.01291 12.5135 6.47753 14.0192L5.4177 17H8.00073H16.0007Z"
                        fill="#FE5000" />
                    </svg>
                  </div>
                  <div class="title">Уведомление об&nbsp;оплате</div>
                </div>
                <div class="card-body">
                  <p>
                    Перед выполнением каждого запроса Сервис выводит на экран
                    стоимость услуги и предлагает Вам подтвердить свое согласие
                    на ее оплату.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal size="md" id="sia_result" title="Результат анализа" :hide-footer="true">
      <div id="sia_progress"></div>
      <div class="sia_result_text">
        <div v-for="row in sia_result_object" class="sia-row" :id="row.key">
          <span class="title">
            {{ row.label }}
          </span>
          <span class="value" v-tippy="{ arrow: true, theme: 'light-border', maxWidth: 280 }" :content="row.value">{{
            row.value }}</span>
          <span class="text-info text-sm" v-tippy="{ arrow: true, theme: 'light-border', maxWidth: 280 }"
            :content="row.value"><i class="fa fa-question-circle"></i></span>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
// var ProgressBar = require('progressbar.js');
const GaugeChart = require("gauge-chart");
// import * as GaugeChart from 'https://unpkg.com/gauge-chart@next/dist/bundle.mjs'

import moment from "moment";
import translatableField from "../../fields/translatable-field.vue";
import html2pdf from "html2pdf.js";
import CNSearchHistory from "../../contracts/contragent-search/helpers/history.vue";
export default {
  components: { translatableField, CNSearchHistory },
  data() {
    return {
      sia_loading: false,
      sia_time: "",
      sia_time_start: 0,
      sia_timer: null,
      sia_result_text: "",
      sia_result_object: [],
      sia: {},

      history_record_id: false, //1662,
      history_record_text:
        "91330000609786330F | ZHEJIANG CHOUZHOU COMMERCIAL BANK CO .,LTD",
      global_log: {},
      global_log_cn: {},
      formatted_kw: "",
      global_kw: "",

      info_1_more: false,

      user_balance: 0,

      loading: -1,
      search_company_info_complete: false,
      court_search_complete: false,
      news_search_complete: false,
      risk_search_complete: false,
      anual_search_complete: false,
      enterprise_fuzzy_complete: false,
      current_tab: 0,
      no_result: 0,
      services_loading: [],
      total_loaded: 0,

      tmp_company_info_for_helpers: {
        EnglishName: "",
        Email: "",
      },

      company_info_data: {
        response_info: {},
        service_info: {},
        areaList: [],
        industryList: [],
        revokeInfoList: [],
        parentInfoList: [],

        UsedNameList: [],
        ShareHolderList: [],
        EmployeeList: [],
        InvestList: [],
        ChangeList: [],
        BranchList: [],
        MoreEmailList: [],
        EntTagList: [],
      },
      court_info_data: {
        response_info: {},
      },
      news_info_data: {
        response_info: {},
      },
      risk_info_data: {
        Industry: {},
        Area: {},
        RevokeInfo: {},
        Penalty: [],
        Exceptions: [],
        ShiXinItems: [],
        ZhiXingItems: [],
        MPledge: [],
        Pledge: [],
        SpotCheck: [],
        CompanyTaxCreditItems: [],
        CompanyProducts: [],
        PermissionEciInfo: [],
        PenaltyCreditChina: [],
        Partners: [],
        Employees: [],
        Branches: [],
        ChangeRecords: [],
        EmergingIndustyList: [],
        TagList: [],
        ARContactList: [],
        OriginalName: [],
        ContactInfo: {},
      },
      business_fuzzy_info: {
        response_info: {},
        Paging: {},
        currency: "",
        price: 0,
      },
      annual_info_data: {},
      keyWord: "",
      keyWordTranslated: "",
      keyWord886: "",
      keyWord886Translated: "",
      pdf_document: {},
      services: [],
      prices: {},
      currency: "",
      service_codes: [
        {
          value: "430",
          display_text: this.$t("message.find_partner.common_info_cn"),
        },
        {
          value: "930",
          display_text: this.$t("message.find_partner.court_notice_info"),
        },
        {
          value: "701",
          display_text: this.$t("message.find_partner.corporate_news_search"),
        },
        {
          value: "213",
          display_text: this.$t("message.contragent_search.annual_report"),
        },
        {
          value: "736",
          display_text: this.$t(
            "message.contragent_search.enterprise_risk_scan",
          ),
        },
        {
          value: "886",
          display_text: this.$t("message.find_partner.fuzzy_search_cn"),
        },
      ],
      provinceCode: "",
      provinceCodeTranslated: "",
      cityCode: "",
      cityCodeTranslated: "",
      pdf_parameters: {},
      timer_seconds: "00",
      timer_minutes: "00",
      interval: "",
      locale: "",
      progress_fuzzy: -1,
      reduceBalanceId: null,
      servicesHasResults: { "886": null },
    };
  },
  mounted() {
    this.doMount();
  },

  methods: {
    humanizeAnalyzeAPIKey(key) {
      switch (key) {
        case "high_risk":
          return "Высокий риск";
        case "plus":
          return "Плюсы";
        case "warnings":
          return "Замечания";
      }
    },
    sendToAnalyze() {
      this.sia_loading = true;
      this.sia_time_start = new Date().getTime() / 1000;
      this.sia_timer = setInterval(() => {
        let cur_time = new Date().getTime() / 1000;
        this.sia_time = (cur_time - this.sia_time_start).toFixed(0) + "s";
      }, 1000);
      axios
        .get(
          window.base +
          "/api/SIA_search?id=" +
          this.history_record_id +
          "&search_text=" +
          this.history_record_text,
        )
        .then((response) => {
          this.sia_loading = false;
          clearInterval(this.sia_timer);
          this.sia = JSON.parse(
            response.data
              .replace('"', '"')
              .replace('""', '"')
              .replace('"{', "{")
              .replace('}"', "}"),
          );
          // this.sia = JSON.parse(response.data.replace('\"', '"').replace('""', '"'))

          this.sia_result_text = "";
          this.sia_result_object = [];
          Object.keys(this.sia).forEach((key) => {
            if (key !== "len_dict" && key !== "complex_grade") {
              this.sia_result_object.push({
                key,
                label: this.humanizeAnalyzeAPIKey(key),
                value: this.sia[key],
              });
              // this.sia_result_text+='<div class="sia-row"><span class="title">'+this.humanizeAnalyzeAPIKey(key)+'</span><span class="value" v-tippy="{ arrow : true, theme: "light-border", maxWidth: 180 }" content="Для продолжения мониторинга включите переключатель">'+this.sia[key]+'</span></div>'
            }
          });

          this.$bvModal.show("sia_result");
          setTimeout(() => {
            let container = document.querySelector("#sia_progress");

            let options5 = {
              hasNeedle: true,
              needleColor: "black",
              arcColors: ["#c0392b", "#e67e22", "#f1c40f", "#27ae60"],
              arcDelimiters: [25, 50, 75],
              arcPadding: 6,
              arcPaddingColor: "white",
              arcLabels: ["50", "100", "150"],
              arcLabelFontSize: false,
              //arcOverEffect: false,
              // label options
              rangeLabel: ["0", "200"],
              centralLabel: this.sia.complex_grade.toFixed(0),
              rangeLabelFontSize: false,
              labelsFont: "Roboto",
            };

            GaugeChart.gaugeChart(container, 200, options5).updateNeedle(
              this.sia.complex_grade / 2,
            );

            // var bar = new ProgressBar.SemiCircle(container, {
            //     strokeWidth: 6,
            //     color: '#2ecc71',
            //     trailColor: '#eee',
            //     trailWidth: 1,
            //     easing: 'easeInOut',
            //     duration: 1400,
            //     svgStyle: null,
            //     text: {
            //         value: '',
            //         alignToBottom: false
            //     },
            //     from: {color: '#e74c3c'},
            //     to: {color: '#2ecc71'},
            //     // Set default step function for all animate calls
            //     step: (state, bar) => {
            //         bar.path.setAttribute('stroke', state.color);
            //         var value = Math.round(bar.value() * 100);
            //         if (value === 0) {
            //         bar.setText('');
            //         } else {
            //         bar.setText(value);
            //         }

            //         bar.text.style.color = state.color;
            //     }
            // });
            // bar.text.style.fontFamily = '"Raleway", Helvetica, sans-serif';
            // bar.text.style.fontSize = '2rem';

            // bar.animate(this.sia.complex_grade/100);
          }, 500);
        })
        .catch(() => {
          this.sia_loading = false;
          clearInterval(this.sia_timer);
        });
    },
    makePdf() {
      var element = document.getElementById("no-results-doc");
      var opt = {
        margin: [0.2, 0.1, 0.2, 0.1],
        filename: "Document_BN_no_match.pdf",
        enableLinks: true,
        //pagebreak:    { mode: 'css', avoid: 'p' },
        pagebreak: { mode: ["avoid-all", "css"] },
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      window.scrollTo(0, 0);
      html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          var totalPages = pdf.internal.getNumberOfPages();
          //print current pdf width & height to consol
          //var imgData = signature.toDataURL('image/png');
          for (var i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            //if(type=='cmr')
            // pdf.addImage(imgData, 'PNG', 12, pdf.internal.pageSize.getHeight()-40)
            //else
            //pdf.addImage(imgData, 'PNG', 0.59, pdf.internal.pageSize.getHeight()-1.37)
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            //divided by 2 to go center
            // if(type=='cmr')
            //     pdf.text(i + ' / ' + totalPages, pdf.internal.pageSize.getWidth()-24, pdf.internal.pageSize.getHeight()-30);
            // else
            //     pdf.text(i + ' / ' + totalPages, pdf.internal.pageSize.getWidth()-1.18, pdf.internal.pageSize.getHeight()-0.59);
          }
        })
        .save();
    },
    hasResults(serviceCode, hasResults) {
      this.servicesHasResults[serviceCode] = hasResults;

      if (Object.values(this.servicesHasResults).find(Boolean)) {
        let fd = new FormData();
        fd.append("id", this.reduceBalanceId);
        fd.append("hasResults", true);
        this.reduceBalanceId && axios.post(window.base + "/account/updateOperationResult", fd);
        this.reduceBalanceId = null;
        this.servicesHasResults = Object.fromEntries(Object.keys(this.servicesHasResults).map((key) => [key, null]));
      }
      if (Object.values(this.servicesHasResults).every((v) => v === false)) {
        let fd = new FormData();
        fd.append("id", this.reduceBalanceId);
        fd.append("hasResults", false);
        this.reduceBalanceId && axios.post(window.base + "/account/updateOperationResult", fd);
        this.reduceBalanceId = null;
        this.servicesHasResults = Object.fromEntries(Object.keys(this.servicesHasResults).map((key) => [key, null]));
      }
    },
    doMount() {
      if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
      window.is_searched = false;
      if (this.is_bank) {
        this.services = ["430", "930", "701", "213", "736"];
        this.servicesHasResults = { "430": null, "930": null, "701": null, "213": null, "736": null };
        this.prices = {};
        this.currency = {};
        this.loadPrices();
      } else {
        this.services = this.$route.params.services;
        this.servicesHasResults = Object.assign({}, ...this.services.map((service) => ({ [service]: null })));
        this.prices = this.$route.params.prices;
        this.currency = this.$route.params.currency;
        this.loadPrices();
      }

      // if(typeof this.prices){
      //     this.loadPrices()
      // }

      this.$root.$on("load-fuzzy-new-page", (reduceBalanceId) => {
        console.log("load-fuzzy-new-page");
        this.reduceBalanceId = reduceBalanceId;
        this.servicesHasResults = { "886": null };
        this.searchenterpriseFuzzy("new-page");
      });
      // console.log(this.services)
      if (
        this.$route.params &&
        this.$route.params.search &&
        this.$route.params.search !== ""
      ) {
        this.keyWord = this.$route.params.search;
        this.searchServices();
      }

      if (
        this.$route.name == "business-note-hist-tab" ||
        this.$route.name == "bn-single"
      ) {
        this.current_tab = 1;
      }
    },
    loadPrices() {
      this.prices = {};
      axios
        .get(window.base + "/account/GetServicesPrice")
        .then((response) => {
          this.services.forEach((key) => {
            if (typeof response.data == "object") {
              var r = response.data.find(
                (element) => element.billing_service_code === key,
              );
              console.log(r);
              this.currency = r.billing_service_cur;
              if (this.$store.state.user.is_privileged)
                this.prices[key] = r.service_price_privileged;
              else this.prices[key] = r.billing_service_price;
            }
          });
          console.log("prices", this.prices);
        })
        .catch(() => {
          console.log("Error loading price list...");
        });
    },
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
    momentum_now(d) {
      return moment().format("D.MM.Y");
    },
    translateText(text) {
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        axios
          .get(
            window.base +
            "/library/TranslateNextNew?text=" +
            text +
            "&source=zh&target=" +
            locale,
          )
          .then((response) => {
            return response.data.translation;
          });
      } else {
        return text;
      }
    },
    translateTextArray(text) {
      console.log("translateTextArray");
      console.table(text);
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        return axios.post(
          window.base +
          "/library/TranslateNextArrayNew?source=zh&target=" +
          locale,
          text,
        );
      }
    },
    translateTextArrayOfArrays(array) {
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        return axios.post(
          window.base +
          "/library/TranslateNextMultiArrayNew?source=zh&target=" +
          locale,
          array,
        );
      }
    },
    async formatObjects(object, list) {
      console.log("formatObjects");
      console.table(object);
      return this.translateTextArray(object).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          list[i].push(JSON.parse(res.data[i]).translation);
        }
        this.company_info_data.service_info = list;
      });
    },
    // formats table data with translations
    async formatObjectTablesCompany(object, list) {
      console.log("formatObjectTables");
      console.table(object);
      console.table(Object.keys(object));
      console.table(Object.values(object));
      if (object) {
        var keys = Object.keys(object);
        var values = Object.values(object);
        return this.translateTextArray(values)
          .then((res) => {
            res.data.forEach((t, i) => {
              if (
                keys[i] === "CreditCode" ||
                keys[i] === "No" ||
                keys[i] === "IndustryCode" ||
                keys[i] === "SubIndustryCode"
              )
                list.push({
                  Key: keys[i],
                  Translated: values[i],
                  Original: values[i],
                });
              else
                list.push({
                  Key: keys[i],
                  Translated: JSON.parse(t).translation,
                  Original: values[i],
                });
            });
          })
          .catch((e) => {
            //console.log('catch formatObjectTables', e)
            //console.log(object);
            return false;
          });
      } else return true;
    },
    async formatArrayObjectTables(object, list) {
      if (object.length > 0) {
        for (const obj of object) {
          var keys = Object.keys(obj);
          var values = Object.values(obj);
          await this.translateTextArray(values)
            .then((res) => {
              var translated = {};
              for (let j = 0; j < res.data.length; j++) {
                if (
                  keys[j] === "CreditCode" ||
                  keys[j] === "No" ||
                  keys[j] === "IndustryCode" ||
                  keys[j] === "SubIndustryCode"
                )
                  translated[keys[j]] = values[j];
                else translated[keys[j]] = JSON.parse(res.data[j]).translation;
              }
              list.push(translated);
            })
            .catch(() => {
              //console.log('catch formatArrayObjectTables')
              return false;
              //console.log('error translating...')
            });
        }
      } else return true;
    },
    async formatObjectTables(object, resObject) {
      console.log("formatObjectTables");
      console.table(object);
      console.table(Object.keys(object));
      console.table(Object.values(object));
      if (object) {
        var keys = Object.keys(object);
        var values = Object.values(object);
        return this.translateTextArray(values).then((res) => {
          res.data.forEach((t, i) => {
            if (
              keys[i] === "CreditCode" ||
              keys[i] === "No" ||
              keys[i] === "IndustryCode" ||
              keys[i] === "SubIndustryCode" ||
              keys[i] == "No" ||
              keys[i] == "Year" ||
              keys[i] == "PublishDate"
            )
              resObject[keys[i]] = values[i];
            else resObject[keys[i]] = JSON.parse(t).translation;
            //list.push({Key: keys[i], Translated: JSON.parse(t).translation, Original: values[i] })
          });
        });
      } else return true;
    },
    async formatArrayObjectTablesAnnual(object, list, object_type = "wrong") {
      if (object.length > 0) {
        list = [];
        for (const obj of object) {
          var keys = Object.keys(obj);
          var values = Object.values(obj);
          await this.translateTextArray(values).then((res) => {
            var translated = {};
            for (let j = 0; j < res.data.length; j++) {
              if (
                keys[j] === "CreditCode" ||
                keys[j] === "No" ||
                keys[j] === "IndustryCode" ||
                keys[j] === "SubIndustryCode" ||
                keys[i] == "No" ||
                keys[i] == "Year" ||
                keys[i] == "PublishDate"
              )
                translated[keys[j] + "Translated"] = values[j];
              else
                translated[keys[j] + "Translated"] = JSON.parse(
                  res.data[j],
                ).translation;
            }
            list.push(translated);
          });
        }
        console.log(object_type, object, list);
        // return await Promise.all(object.map(async (obj) => {

        // }))
        // object.forEach((obj, i) => {
        //     var keys = Object.keys(obj);
        //     var values = Object.values(obj);
        //     return this.translateTextArray(values).then(res => {
        //         var translated = {};
        //         for (let j = 0; j < res.data.length; j++) {
        //             if (keys[j] === 'CreditCode' || keys[j] === 'No' || keys[j] ==='IndustryCode' || keys[j] === 'SubIndustryCode')
        //                 translated[keys[j]] = values[j];
        //             else
        //                 translated[keys[j]] = JSON.parse(res.data[j]).translation;
        //         }
        //         list.push(translated);

        //     })
        // })
      } else return true;
    },

    formatStringValues(values, keys) {
      var locale = this.$i18n.locale;

      this.translateTextArray(values).then((res) => {
        res.data.forEach((r, i) => {
          if (locale !== "cn")
            this.risk_info_data[keys[i]] = JSON.parse(r).translation;
          else this.risk_info_data[keys[i]] = values[i];
        });
      });
    },

    async makeBulkTranslation({ objects, tables, object_tables, strings }) {
      console.warn("bulk input", objects, tables, object_tables);
      const request = [];
      const request_tmp = [];
      if (typeof objects[0] !== "undefined") {
        objects.forEach((item) => request.push(Object.values(item).map(item => {
          if (typeof item != 'object') {
            return item;
          } else {
            return "";
          }
        })));
      }
      if (typeof tables[0] !== "undefined") {
        tables.forEach((item) => {
          const values = Object.values(item).map(item => {
            if (typeof item != 'object') {
              return item;
            } else {
              return "";
            }
          });
          if (values.length > 0) request.push(values);
        });
      }
      if (typeof object_tables[0] !== "undefined") {
        object_tables.forEach((table) => {
          if (Array.isArray(table)) {
            table.forEach((object) => {
              const values = Object.values(object).map(item => {
                if (typeof item != 'object') {
                  return item;
                } else {
                  return "";
                }
              });
              if (values.length > 0) request.push(values);
            });
          }
        });
      }
      if (typeof strings[0] !== "undefined") {
        strings.forEach((object) => {
          request.push(object.stringValues);
        });
      }

      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        const objects_translated = [];
        const tables_translated = [];
        const object_tables_translated = [];

        const response = await axios.post(
          window.base +
          "/library/TranslateNextMultiArray?source=zh&target=" +
          locale,
          request,
        ); //.then(response=>{
        let global_counter = 0;

        const data = response.data;
        console.log(request, data);
        if (typeof objects[0] !== "undefined") {
          objects.forEach((item, index) => {
            objects_translated.push(
              response.data[global_counter].map(
                (translated) => JSON.parse(translated).translation,
              ),
            );
            global_counter++;
          });
        }
        if (typeof tables[0] !== "undefined") {
          tables.forEach((item, index) => {
            const values = Object.values(item);
            if (values.length > 0) {
              const keys = Object.keys(item);
              console.log("kekekey", keys);
              const translated_object = [];
              // keys.forEach((key, key_index)=>{
              response.data[global_counter].forEach((t, i) => {
                if (
                  keys[i] === "CreditCode" ||
                  keys[i] === "No" ||
                  keys[i] === "IndustryCode" ||
                  keys[i] === "SubIndustryCode" /*|| keys[i]=='Year'*/ ||
                  keys[i] == "PublishDate"
                ) {
                  translated_object.push({
                    Key: keys[i],
                    Translated: values[i],
                    Original: values[i],
                  });
                } else {
                  translated_object.push({
                    Key: keys[i],
                    Translated: JSON.parse(t).translation,
                    Original: values[i],
                  });
                }
              });
              // })
              global_counter++;
              tables_translated.push(translated_object);
            } else {
              tables_translated.push(item);
            }
          });
        }
        console.log("tables_translated", tables_translated);
        console.log("ot", object_tables);
        if (typeof object_tables[0] !== "undefined") {
          object_tables.forEach((object) => {
            const translated_object_table = [];
            console.log("objt", object);
            if (Array.isArray(object)) {
              object.forEach((item) => {
                const values = Object.values(item);
                console.warn(
                  "trans",
                  global_counter,
                  response.data[global_counter],
                );
                if (values.length > 0) {
                  const keys = Object.keys(item);
                  const translated_object = {};
                  keys.forEach((key, key_index) => {
                    console.log("keyj", key);
                    if (
                      typeof response.data[global_counter] !== "undefined" &&
                      Array.isArray(response.data[global_counter])
                    )
                      if (
                        typeof response.data[global_counter][key_index] !==
                        "undefined"
                      ) {
                        try {
                          translated_object[key] = JSON.parse(
                            response.data[global_counter][key_index],
                          ).translation;
                        } catch (e) {
                          console.log(e)
                        }
                      }
                  });

                  translated_object_table.push(translated_object);
                } else {
                  translated_object_table.push(item);
                }
                global_counter++;
              });
            }
            object_tables_translated.push(translated_object_table);
          });
        }
        console.log("ot_", object_tables_translated);
        const strings_translated = [];
        if (typeof strings[0] !== "undefined") {
          strings.forEach((object) => {
            const tmp_object = {};

            object.stringKeys.forEach((key, i) => {
              if (Array.isArray(response.data[global_counter]))
                tmp_object[key] = JSON.parse(
                  response.data[global_counter][i],
                ).translation;
            });
            strings_translated.push(tmp_object);
            global_counter++;
          });
        }

        console.warn(
          objects_translated.length,
          tables_translated.length,
          object_tables_translated.length,
        );
        return {
          objects: objects_translated,
          tables: tables_translated,
          object_tables: object_tables_translated,
          strings: strings_translated,
        };
        // })
      }
      return { objects, tables, object_tables, strings };
    },

    async getCompanyInfoTranslations(
      service_to_translate,
      tmp_service_info,
      tmp_response_info,
    ) {
      return new Promise(async (resolve, reject) => {
        const {
          objects: [service_info],
          tables: [areaList, industryList, revokeInfoList, parentInfoList],
          object_tables: [
            EntTagList,
            ChangeList,
            UsedNameList,
            ShareHolderList,
            EmployeeList,
            InvestList,
            BranchList,
            MoreEmailList,
          ],
        } = await this.makeBulkTranslation({
          objects: [service_to_translate],
          tables: [
            tmp_response_info.Area,
            tmp_response_info.Industry,
            tmp_response_info.RevokeInfo,
            tmp_response_info.ParentInfo,
          ],
          object_tables: [
            tmp_response_info.EntTagList,
            tmp_response_info.ChangeList,
            tmp_response_info.UsedNameList,
            tmp_response_info.ShareHolderList,
            tmp_response_info.EmployeeList,
            tmp_response_info.InvestList,
            tmp_response_info.BranchList,
            tmp_response_info.MoreEmailList,
          ],
          strings: [],
        });
        // console.log(data)
        let real_service_info = [];
        real_service_info = tmp_service_info.map((item, index) => {
          return [item[0], item[1], service_info[index]];
          // return item
        });
        // 91110105599635386M

        this.$set(this.company_info_data, "service_info", real_service_info);
        this.$set(this.company_info_data, "areaList", areaList);
        this.$set(this.company_info_data, "industryList", industryList);
        this.$set(this.company_info_data, "revokeInfoList", revokeInfoList);
        this.$set(this.company_info_data, "parentInfoList", parentInfoList);

        this.$set(this.company_info_data, "EntTagList", EntTagList);
        this.$set(this.company_info_data, "ChangeList", ChangeList);
        this.$set(this.company_info_data, "UsedNameList", UsedNameList);
        this.$set(this.company_info_data, "ShareHolderList", ShareHolderList);
        this.$set(this.company_info_data, "EmployeeList", EmployeeList);
        this.$set(this.company_info_data, "InvestList", InvestList);
        this.$set(this.company_info_data, "BranchList", BranchList);
        this.$set(this.company_info_data, "MoreEmailList", MoreEmailList);
        resolve();
      });
    },
    async getRiskScanTranslations(response, stringValues, stringKeys) {
      // this.formatStringValues(stringValues, stringKeys, this.risk_info_data)
      return new Promise(async (resolve, reject) => {
        const {
          objects: [],
          tables: [Industry, Area, RevokeInfo, ContactInfo],
          object_tables: [
            Penalty,
            Exceptions,
            ShiXinItems,
            ZhiXingItems,
            MPledge,
            Pledge,
            SpotCheck,
            CompanyTaxCreditItems,
            CompanyProducts,
            PermissionEciInfo,
            PenaltyCreditChina,
            Partners,
            Employees,
            Branches,
            ChangeRecords,
            EmergingIndusty,
            TagList,
            ARContactList,
            OriginalName,
          ],
          strings: [strings],
        } = await this.makeBulkTranslation({
          objects: [],
          tables: [
            response.data.Result.Industry,
            response.data.Result.Area,
            response.data.Result.RevokeInfo,
            response.data.Result.ContactInfo,
          ],
          object_tables: [
            response.data.Result.Penalty,
            response.data.Result.Exceptions,
            response.data.Result.ShiXinItems,
            response.data.Result.ZhiXingItems,
            response.data.Result.MPledge,
            response.data.Result.Pledge,
            response.data.Result.SpotCheck,
            response.data.Result.CompanyTaxCreditItems,
            response.data.Result.CompanyProducts,
            response.data.Result.PermissionEciInfo,
            response.data.Result.PenaltyCreditChina,
            response.data.Result.Partners,
            response.data.Result.Employees,
            response.data.Result.Branches,
            response.data.Result.ChangeRecords,
            response.data.Result.EmergingIndustyList,
            response.data.Result.TagList,
            response.data.Result.ARContactList,
            response.data.Result.OriginalName,
          ],
          strings: [{ stringValues, stringKeys }],
        });
        console.log(strings);
        Object.keys(strings).forEach((key) => {
          this.$set(this.risk_info_data, key, strings[key]);
        });
        this.$set(this.risk_info_data, "Industry", Industry);
        this.$set(this.risk_info_data, "Area", Area);
        this.$set(this.risk_info_data, "RevokeInfo", RevokeInfo);
        this.$set(this.risk_info_data, "ContactInfo", ContactInfo);
        this.$set(this.risk_info_data, "Penalty", Penalty);
        this.$set(this.risk_info_data, "Exceptions", Exceptions);
        this.$set(this.risk_info_data, "ShiXinItems", ShiXinItems);
        this.$set(this.risk_info_data, "ZhiXingItems", ZhiXingItems);
        this.$set(this.risk_info_data, "MPledge", MPledge);
        this.$set(this.risk_info_data, "Pledge", Pledge);
        this.$set(this.risk_info_data, "SpotCheck", SpotCheck);
        this.$set(
          this.risk_info_data,
          "CompanyTaxCreditItems",
          CompanyTaxCreditItems,
        );
        this.$set(this.risk_info_data, "CompanyProducts", CompanyProducts);
        this.$set(this.risk_info_data, "PermissionEciInfo", PermissionEciInfo);
        this.$set(
          this.risk_info_data,
          "PenaltyCreditChina",
          PenaltyCreditChina,
        );
        this.$set(this.risk_info_data, "Partners", Partners);
        this.$set(this.risk_info_data, "Employees", Employees);
        this.$set(this.risk_info_data, "Branches", Branches);
        this.$set(this.risk_info_data, "ChangeRecords", ChangeRecords);
        this.$set(this.risk_info_data, "EmergingIndusty", EmergingIndusty);
        this.$set(this.risk_info_data, "TagList", TagList);
        this.$set(this.risk_info_data, "ARContactList", ARContactList);
        this.$set(this.risk_info_data, "OriginalName", OriginalName);
        resolve();
      });
    },
    getAnnualTranslations(result) {
      return new Promise((resolve, reject) => {
        const result_ = [];
        result.map((res, index) => {
          this.makeBulkTranslation({
            objects: [],
            tables: [res.BasicInfoData, res.AssetsData, res.SocialInsurance],
            object_tables: [
              res.ChangeList,
              res.InvestInfoList,
              res.PartnerList,
              res.ProvideAssuranceList,
              res.StockChangeList,
              res.WebSiteList,
              res.AdministrationLicenseList,
              res.BranchList,
              res.EmployeeList,
            ],
            strings: [],
          }).then(
            ({
              objects: [],
              tables: [BasicInfoData_, AssetsData_, SocialInsurance_],
              object_tables: [
                ChangeList_,
                InvestInfoList_,
                PartnerList_,
                ProvideAssuranceList_,
                StockChangeList_,
                WebSiteList_,
                AdministrationLicenseList_,
                BranchList_,
                EmployeeList_,
              ],
            }) => {
              console.warn(PartnerList_);
              console.warn({
                BasicInfoData: BasicInfoData_,
                AssetsData: AssetsData_,
                SocialInsurance: SocialInsurance_,
                ChangeList: ChangeList_,
                InvestInfoList: InvestInfoList_,
                PartnerList: PartnerList_,
                ProvideAssuranceList: ProvideAssuranceList_,
                StockChangeList: StockChangeList_,
                WebSiteList: WebSiteList_,
                AdministrationLicenseList: AdministrationLicenseList_,
                BranchList: BranchList_,
                EmployeeList: EmployeeList_,
              });
              result_.push({
                BasicInfoData: BasicInfoData_,
                AssetsData: AssetsData_,
                SocialInsurance: SocialInsurance_,
                ChangeList: ChangeList_,
                InvestInfoList: InvestInfoList_,
                PartnerList: PartnerList_,
                ProvideAssuranceList: ProvideAssuranceList_,
                StockChangeList: StockChangeList_,
                WebSiteList: WebSiteList_,
                AdministrationLicenseList: AdministrationLicenseList_,
                BranchList: BranchList_,
                EmployeeList: EmployeeList_,
              });
              console.warn(result_);
              if (index == result.length - 1) {
                resolve(result_);
              }
            },
          );
        });
      });
    },
    requestServices() {
      if (this.services.includes("430"))
        //companyinfo
        this.searchCompanyInfo();
      if (this.services.includes("930"))
        // court
        this.searchCourtInfo();
      if (this.services.includes("701"))
        // news
        this.searchNewsInfo();
      if (this.services.includes("213"))
        // annual
        this.searchAnnualInfo();

      if (this.services.includes("736"))
        // risk
        this.searchRiskScanInfo();
      if (this.services.includes("886"))
        // enterprisefuzzy
        this.searchenterpriseFuzzy("1");
    },
    async searchServices() {
      this.company_info_data = {
        response_info: {},
        service_info: {},
        areaList: [],
        industryList: [],
        revokeInfoList: [],
        parentInfoList: [],

        UsedNameList: [],
        ShareHolderList: [],
        EmployeeList: [],
        InvestList: [],
        ChangeList: [],
        BranchList: [],
        MoreEmailList: [],
        EntTagList: [],
      };

      this.annual_info_data = {};
      this.pdf_document = {};

      this.court_info_data = {
        response_info: {},
      };
      this.news_info_data = {
        response_info: {},
      };
      this.risk_info_data = {
        Industry: {},
        Area: {},
        RevokeInfo: {},
        Penalty: [],
        Exceptions: [],
        ShiXinItems: [],
        ZhiXingItems: [],
        MPledge: [],
        Pledge: [],
        SpotCheck: [],
        CompanyTaxCreditItems: [],
        CompanyProducts: [],
        PermissionEciInfo: [],
        PenaltyCreditChina: [],
        Partners: [],
        Employees: [],
        Branches: [],
        ChangeRecords: [],
        EmergingIndustyList: [],
        TagList: [],
        ARContactList: [],
        OriginalName: [],
        ContactInfo: {},
      };
      this.business_fuzzy_info = {
        response_info: {},
        Paging: {},
        currency: "",
        price: 0,
      };

      this.no_result = 0;
      this.services_loading = [];
      this.total_loaded = 0;

      this.loading = -1;

      this.search_company_info_complete = false;
      this.court_search_complete = false;
      this.news_search_complete = false;
      this.risk_search_complete = false;
      this.anual_search_complete = false;
      this.enterprise_fuzzy_complete = false;

      this.pdf_parameters.keyWord = this.keyWord;
      this.pdf_parameters.keyWord886 = this.keyWord886;
      this.pdf_parameters.provinceCode = this.provinceCode;
      this.pdf_parameters.cityCode = this.cityCode;

      this.total_loaded = 0;
      this.locale = this.$i18n.locale;
      this.services_loading = [];
      axios.get(window.base + "/document/getfirmfull").then((response) => {
        if (response.data.persons) {
          this.pdf_parameters.searcher_full_name =
            response.data.persons.given_name +
            " " +
            response.data.persons.middle_name +
            " " +
            response.data.persons.last_name;
        }
      });
      console.log(this.services);
      this.services.forEach((obj) => {
        var srv = {};
        srv.service = obj;
        srv.loading_step = 0;
        this.services_loading.push(srv);
      });
      console.log(this.services_loading);

      axios.get(window.base + "/account/balance").then((response) => {
        this.user_balance = parseFloat(response.data);
        if (isNaN(this.user_balance)) this.user_balance = 0;

        //console.log('params services');
        //console.log(this.services);
        var message = "";
        var price = 0;
        this.services.forEach((serv) => {
          price += this.prices[serv];
        });
        if (this.services.length > 1) {
          var names = this.service_codes
            .map((obj) => {
              if (this.services.includes(obj.value)) return obj.display_text;
            })
            .join(",");
          message =
            this.$t("message.find_partner.cn_bulk_services_alert").replace(
              "{}",
              names,
            ) +
            " " +
            window.rubFormat(price, this.currency);
        } else {
          var name = this.service_codes.find((obj) => {
            return obj.value === this.services[0];
          });
          message =
            this.$t("message.find_partner.cn_single_service_alert").replace(
              "{}",
              name.display_text,
            ) +
            " " +
            window.rubFormat(price, this.currency) +
            ". " +
            this.$t("message.account.you_have") +
            " " +
            window.rubFormat(this.user_balance, this.currency);
        }
        if (this.user_balance < price || this.user_balance <= 0) {
          this.$bvModal.msgBoxOk(
            this.$t("message.account.not_enough_funds_message"),
            {
              title: this.$t("message.confirm"),
              size: "md",
              buttonSize: "sm",
              okVariant: "success",
              headerClass: "p-2 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true,
            },
          );
        } else {
          this.$bvModal
            .msgBoxConfirm(message, {
              title: this.$t("message.confirm"),
              size: "md",
              buttonSize: "sm",
              okVariant: "danger",
              okTitle: this.$t("message.yes"),
              cancelTitle: this.$t("message.no"),
              footerClass: "p-2",
              hideHeaderClose: false,
              centered: true,
            })
            .then(async (value) => {
              if (value) {
                let fd = new FormData();
                if (isNaN(price)) price = 0;
                fd.append("amount", price);
                fd.append("service_code", this.services.join(","));
                fd.append("search_keyword", this.keyWordTranslated);
                this.reduceBalanceData = (await axios.post(window.base + "/account/reduceBalance", fd)).data;
                this.reduceBalanceId = this.reduceBalanceData?.id || null;
                        
                if (this.reduceBalanceData?.isAccountBalanceLow) {
                  this.$bvModal.msgBoxOk(this.$t("message.message.account_balance_is_low", { balance: window.rubFormat(this.reduceBalanceData.accountBalance, this.currency) }), {
                    title: this.$t("message.confirm"),
                    size: "md",
                    buttonSize: "sm",
                    okVariant: "success",
                    okTitle: this.$t("message.ok"),
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                  });
                }
                
                this.servicesHasResults = Object.fromEntries(Object.keys(this.servicesHasResults).map((key) => [key, null]));
                this.$root.$emit("reduceBalance", { price: price });
                this.startTimer();
                this.loading = this.services.length;
                this.total_loaded++;

                switch (this.locale) {
                  case "cn":
                    this.locale = "zh";
                    break;
                  case "en":
                    this.locale = "en";
                    break;
                  case "ru":
                    this.locale = "ru";
                    break;
                }
                if (this.locale == "ru") {
                  let paramArray = [];
                  paramArray.push(this.keyWord);
                  paramArray.push(this.keyWord886);
                  paramArray.push(this.provinceCode);
                  paramArray.push(this.cityCode);
                  axios
                    .post(
                      window.base +
                      "/library/TranslateNextArrayNew?source=ru&target=en",
                      paramArray,
                    )
                    .then((res) => {
                      // let translatedParams = res.data.map((trn) => {
                      //     if (JSON.parse(trn).translation)
                      //         return JSON.parse(trn).translation;
                      // })
                      let translatedParams = res.data.filter((trn) => {
                        if (JSON.parse(trn).translation)
                          return JSON.parse(trn).translation;
                      });

                      console.log("checkin array", translatedParams);
                      // var translationMessage = this.$t('message.find_partner.search_parameters_translation') + translatedParams.map(trn => { return JSON.parse(trn).translation }).join(',');
                      // this.$bvModal.msgBoxConfirm(translationMessage, {
                      //     title: this.$t('message.confirm'),
                      //     size: 'sm',
                      //     buttonSize: 'sm',
                      //     okVariant: 'danger',
                      //     okTitle: this.$t('message.yes'),
                      //     cancelTitle: this.$t('message.no'),
                      //     footerClass: 'p-2',
                      //     hideHeaderClose: false,
                      //     centered: true
                      //     }).then(value => {
                      //         if (value) {
                      //             setTimeout(() => {
                      //                 this.keyWordTranslated = JSON.parse(res.data[0]).translation
                      //                 this.keyWord886Translated = JSON.parse(res.data[1]).translation
                      //                 this.provinceCodeTranslated = JSON.parse(res.data[2]).translation
                      //                 this.cityCodeTranslated = JSON.parse(res.data[3]).translation
                      //                 this.requestServices();
                      //             }, 2000)
                      //         }
                      //         else {
                      this.keyWordTranslated = this.keyWord;
                      this.keyWord886Translated = this.keyWord886;
                      this.provinceCodeTranslated = this.provinceCode;
                      this.cityCodeTranslated = this.cityCode;
                      this.requestServices();
                      //     }

                      // })
                    });
                } else {
                  this.keyWordTranslated = this.keyWord;
                  this.keyWord886Translated = this.keyWord886;
                  this.provinceCodeTranslated = this.provinceCode;
                  this.cityCodeTranslated = this.cityCode;
                  this.requestServices();
                }
              }
            });
        }
      });
    },

    /*async*/ groupAnnualResults(results) {
      console.log("group");
      console.log(results);
      return new Promise((resolve, reject) => {
        console.log("before");
        console.table(results);

        results = results.map((result) => {
          for (let key in result) {
            let data = result[key];
            if (typeof data !== "object") {
              console.log("string", data);
              result[key] = data;
            } else {
              console.warn(key);
              if (
                key == "BasicInfoData" ||
                key == "AssetsData" ||
                key == "SocialInsurance"
              ) {
                if (Array.isArray(data)) {
                  const data_ = {};
                  console.log("not string");
                  data.forEach((item) => {
                    console.log("item", item);
                    data_[item.Key] = item.Translated;
                  });
                  result[key] = data_;
                }
              } else {
                result[key] = data;
              }
            }
          }
          return result;
        });
        console.log("after");
        console.table(results);
        /*await*/ results.forEach(
          /*async*/(result) => {
            if (
              Object.keys(this.annual_info_data).indexOf(
                result.BasicInfoData.RegNo,
              ) == -1
            ) {
              //add new company
              this.annual_info_data[result.BasicInfoData.RegNo] = {
                basic_info: result.BasicInfoData,
                results: [result],
              };
              //console.log('groupresults');
              //console.log(this.annual_info_data);
            } else {
              //add result to existing company
              this.annual_info_data[result.BasicInfoData.RegNo].results.push(
                result,
              );
              //console.log('groupresults else');
              //console.log(this.annual_info_data);
            }
          },
        );
        resolve();
      });
    },
    searchenterpriseFuzzy(mode) {
      let page = 1;
      if (mode !== "new-page") {
        this.enterprise_fuzzy_complete = false;
        this.addLoading("886");
      } else {
        this.progress_fuzzy = 1;
        page = this.business_fuzzy_info.Paging.PageIndex + 1;
      }
      //
      axios
        .get(window.base + "/library/openAPIEnterpriseFuzzySearchNew?keyWord=" +
          this.keyWord886Translated +
          "&provinceCode=" +
          this.provinceCodeTranslated +
          "&cityCode=" +
          this.cityCodeTranslated +
          "&pageIndex=" +
          page,
        )
        .then((response) => {
          // this.logServiceRequest('886', this.keyWord886 + ' ' + this.provinceCode + ' ' + this.cityCode, response.data);
          var result = response.data.Result;
          if (mode !== "new-page") this.addLoading("886");
          else this.progress_fuzzy = 2;

          if (!result) {
            this.hasResults("886", false);
            if (mode !== "new-page") {
              this.loading--;
              this.no_result++;
            } else this.progress_fuzzy = 3;

            this.logServiceRequest(
              "886",
              this.keyWord886 + " " + this.provinceCode + " " + this.cityCode,
              {},
              { Status: "900" },
            );

            // new Noty({
            //     theme: 'light',
            //     type: 'warning',
            //     text: this.$t('message.find_partner.data_is_not_found').replace('{x}', this.$t('message.find_partner.fuzzy_search_cn')).replace('{y}', this.keyWord886 + ' ' + this.provinceCode + ' ' + this.cityCode),
            //     timeout: 5000,
            // }).show();
            return;
          }
          this.hasResults("886", true);
          var tmp = [];
          this.formatArrayObjectTables(response.data.Result, tmp).then(
            (res) => {
              if (mode !== "new-page") {
                this.addLoading("886");
                this.business_fuzzy_info.response_info = tmp;
              } else {
                this.progress_fuzzy = 3;
                this.business_fuzzy_info.response_info.push(...tmp);
              }

              this.business_fuzzy_info.Paging = response.data.Paging;
              this.business_fuzzy_info.currency = this.currency;
              this.business_fuzzy_info.price = this.prices["886"];
              this.enterprise_fuzzy_complete = true;
              this.pdf_document.business_fuzzy_info = this.business_fuzzy_info;
              // console.log('ttt', this.company_info_data)
              this.logServiceRequest(
                "886",
                this.keyWord886 + " " + this.provinceCode + " " + this.cityCode,
                this.business_fuzzy_info,
                response.data,
              );

              if (mode !== "new-page") this.loading--;
            },
          );
        })
        .catch(() => {
          this.hasResults("886", false);
          if (mode !== "new-page") {
            this.loading--;
            this.addLoading("886");
          } else this.progress_fuzzy = 3;

          this.no_result++;
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.find_partner.fuzzy_search_cn"),
              ) +
              this.keyWord886 +
              " " +
              this.provinceCode +
              " " +
              this.cityCode,
            timeout: 5000,
          }).show();
        });
    },

    searchAnnualInfo() {
      this.addLoading("213");
      this.anual_search_complete = false;
      axios
        .get(window.base + "/library/openAPIAnnualReportNew?keyWord=" + this.keyWordTranslated)
        .then((response) => {
          this.addLoading("213");

          // this.logServiceRequest('213', this.keyWord, response.data);
          var result = response.data.Result;
          console.log("serv213", typeof response.data.Result);
          if (typeof response.data.Result !== "object") {
            this.hasResults("213", false);
            console.log("serv213conf");
            this.addLoading("213");
            this.logServiceRequest("213", this.keyWord, {}, { Status: "900" });
            this.no_result++;
            this.loading--;
            //console.log('loading annual 1')
            // new Noty({
            //     theme: 'light',
            //     type: 'warning',
            //     text: this.$t('message.find_partner.data_is_not_found').replace('{x}', this.$t('message.contragent_search.annual_report')).replace('{y}', this.keyWord),
            //     timeout: 5000,
            // }).show();
            return;
          }
          this.hasResults("213", true);

          if (
            response.data.Result.BasicInfoData &&
            response.data.Result.BasicInfoData.CompanyName
          )
            this.tmp_company_info_for_helpers.EnglishName =
              response.data.Result.BasicInfoData.CompanyName;
          else
            this.tmp_company_info_for_helpers.EnglishName =
              this.keyWordTranslated;

          if (
            response.data.Result.ContactInfo &&
            response.data.Result.BasicInfoData.EmailAddress
          )
            this.tmp_company_info_for_helpers.Email =
              response.data.Result.BasicInfoData.EmailAddress;
          else this.tmp_company_info_for_helpers.Email = false;
          console.log("before trans");
          console.table(result);

          let result_ = result.map((item) => {
            const year = item.Year;
            const no = item.No;
            const date = item.PublishDate;

            if (typeof item.AssetsData !== "object") item.AssetsData = {};
            item.AssetsData.Year = year;
            item.AssetsData.No = no;
            item.AssetsData.PublishDate = date;
            if (typeof item.BasicInfoData !== "object") item.BasicInfoData = {};
            item.BasicInfoData.Year = year;
            item.BasicInfoData.No = no;
            item.BasicInfoData.PublishDate = date;
            if (typeof item.SocialInsurance !== "object")
              item.SocialInsurance = {};
            item.SocialInsurance.Year = year;
            item.SocialInsurance.No = no;
            item.SocialInsurance.PublishDate = date;

            item.BranchList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.ChangeList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.EmployeeList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.InvestInfoList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.ProvideAssuranceList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.StockChangeList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            return item;
          });
          console.warn("RES", result_);
          this.getAnnualTranslations(result_).then((r) => {
            this.addLoading("213");

            //console.log('kkkk;', result.InvestInfoList)
            this.groupAnnualResults(r).then((re) => {
              this.anual_search_complete = true;
              this.loading--;
              //console.log('annual info data');
              //console.log(this.annual_info_data);
              //console.log(this.anual_search_complete)
              //console.log(this.loading);
              this.pdf_document.annual_info_data = this.annual_info_data;
              // console.log('ttt', this.annual_info_data)
              this.logServiceRequest(
                "213",
                this.keyWord,
                this.annual_info_data,
                response.data,
              );
            });
            //console.log('loading annual 2')
          });
        })
        .catch(() => {
          this.hasResults("213", false);
          this.addLoading("213");
          this.loading--;
          this.no_result++;
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.contragent_search.annual_report"),
              ) + this.keyWord,
            timeout: 5000,
          }).show();
        });
    },
    searchRiskScanInfo() {
      this.addLoading("736");
      this.risk_search_complete = false;
      axios
        .get(window.base + "/library/openAPIRiskScanNew?keyWord=" + this.keyWordTranslated)
        .then((response) => {
          // this.logServiceRequest('736', this.keyWord, response.data);
          this.addLoading("736");

          if (!response.data.Result) {
            this.hasResults("736", false);
            this.addLoading("736");
            this.loading--;
            this.logServiceRequest("736", this.keyWord, {}, { Status: "900" });
            this.no_result++;
            //console.log('risk 1')
            // new Noty({
            //     theme: 'light',
            //     type: 'warning',
            //     text: this.$t('message.find_partner.data_is_not_found').replace('{x}', this.$t('message.contragent_search.enterprise_risk_scan')).replace('{y}', this.keyWord),
            //     timeout: 5000,
            // }).show();
            return;
          }
          this.hasResults("736", true);

          this.tmp_company_info_for_helpers.EnglishName =
            response.data.Result.Name;
          if (
            response.data.Result.ContactInfo &&
            response.data.Result.ContactInfo.Email
          )
            this.tmp_company_info_for_helpers.Email =
              response.data.Result.ContactInfo.Email;
          else this.tmp_company_info_for_helpers.Email = false;

          var locale = this.$i18n.locale;
          var tmp = Object.entries(response.data.Result);
          tmp = tmp.filter(
            (item) => typeof item[1] !== "object" && !_.isArray(item[1]),
          );
          var stringValues = tmp.map((str) => {
            return str[1];
          });
          var stringKeys = tmp.map((str) => {
            return str[0];
          });
          this.formatStringValues(stringValues, stringKeys);
          if (locale !== "cn") {
            this.getRiskScanTranslations(
              response,
              stringValues,
              stringKeys,
            ).then((res) => {
              this.addLoading("736");
              this.risk_search_complete = true;
              this.pdf_document.risk_info_data = this.risk_info_data;

              this.logServiceRequest(
                "736",
                this.keyWord,
                this.risk_info_data,
                response.data,
              );
              this.loading--;
              //console.log('risk 2')
            });
          } else {
            this.risk_info_data = response.data.Result;
            this.risk_search_complete = true;
            this.pdf_document.risk_info_data = this.risk_info_data;
            this.loading--;
            //console.log('risk 3')
          }
        })
        .catch(() => {
          this.hasResults("736", false);
          this.loading--;
          this.addLoading("736");
          this.no_result++;
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.contragent_search.enterprise_risk_scan"),
              ) + this.keyWord,
            timeout: 5000,
          }).show();
        });
    },
    searchNewsInfo() {
      this.news_search_complete = false;
      this.addLoading("701");

      axios
        .get(window.base + "/library/openAPINewsNew?keyWord=" + this.keyWordTranslated)
        .then((response) => {
          // this.logServiceRequest('701', this.keyWord, response.data);
          if (!response.data.Result) {
            this.hasResults("701", false);
            this.addLoading("701");
            this.logServiceRequest("701", this.keyWord, {}, { Status: "900" });
            this.no_result++;
            // new Noty({
            //     theme: 'light',
            //     type: 'warning',
            //     text: this.$t('message.find_partner.data_is_not_found').replace('{x}', this.$t('message.find_partner.corporate_news_search')).replace('{y}', this.keyWord),
            //     timeout: 5000,
            // }).show();
            this.loading--;
            return;
          }
          this.hasResults("701", true);

          this.tmp_company_info_for_helpers.EnglishName =
            this.keyWordTranslated;
          this.tmp_company_info_for_helpers.Email = false;

          var tmp = [];
          this.formatArrayObjectTables(response.data.Result, tmp).then(
            (res) => {
              this.addLoading("701");

              this.news_info_data.response_info = tmp;

              //console.log('news 1')

              this.news_search_complete = true;
              this.pdf_document.news_info_data = this.news_info_data;

              this.logServiceRequest(
                "701",
                this.keyWord,
                this.news_info_data,
                response.data,
              );
              setTimeout(() => {
                this.loading--;
              }, 5000);
            },
          );
        })
        .catch(() => {
          this.hasResults("701", false);
          this.loading--;
          this.no_result++;
          this.addLoading("701");

          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.find_partner.corporate_news_search"),
              ) + this.keyWord,
            timeout: 5000,
          }).show();
        });
    },
    searchCourtInfo() {
      this.court_search_complete = false;
      this.addLoading("930");
      axios
        .get(window.base + "/library/openAPICourtNew?keyWord=" + this.keyWordTranslated)
        .then((response) => {
          // this.logServiceRequest('930', this.keyWord, response.data);
          this.addLoading("930");

          if (
            response.data.Result.VerifyResult == 1 &&
            response.data.Result.Data.length > 0
          ) {
            this.hasResults("930", true);
            this.tmp_company_info_for_helpers.EnglishName =
              this.keyWordTranslated;
            this.tmp_company_info_for_helpers.Email = false;

            response.data.Result.Data.map((item) => {
              if (item.ProsecutorList.length > 0) {
                item.ProsecutorList = item.ProsecutorList.map((value) => {
                  return value.Name;
                }).join(",");
              }

              if (item.DefendantList.length > 0) {
                item.DefendantList = item.DefendantList.map((value) => {
                  return value.Name;
                }).join(",");
              }

              return item;
            });
            var tmp = {};
            tmp.Data = [];
            this.formatArrayObjectTables(
              response.data.Result.Data,
              tmp.Data,
            ).then((res) => {
              this.addLoading("930");

              //console.log('court 1')

              this.court_search_complete = true;
              this.court_info_data.response_info = tmp;
              this.court_info_data.response_info.VerifyResult =
                response.data.Result.VerifyResult;
              this.pdf_document.court_info_data = this.court_info_data;

              this.logServiceRequest(
                "930",
                this.keyWord,
                this.court_info_data,
                response.data,
              );
              setTimeout(() => {
                this.loading--;
              }, 5000);
            });
          } else {
            this.hasResults("930", false);
            this.addLoading("930");
            this.logServiceRequest("930", this.keyWord, {}, { Status: "900" });
            this.no_result++;
            // new Noty({
            //     theme: 'light',
            //     type: 'warning',
            //     text: this.$t('message.find_partner.data_is_not_found').replace('{x}', this.$t('message.find_partner.court_notice_info')).replace('{y}', this.keyWord),
            //     timeout: 5000,
            // }).show();
            this.loading--;
            return;
          }
        })
        .catch(() => {
          this.hasResults("930", false);
          this.addLoading("930");
          this.no_result++;
          this.loading--;
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.find_partner.court_notice_info"),
              ) + this.keyWord,
            timeout: 5000,
          }).show();
        });
    },
    searchCompanyInfo() {
      this.addLoading("430");

      axios
        .get(window.base + "/library/openAPIQCCNew?keyWord=" + this.keyWordTranslated)
        .then((response) => {
          this.addLoading("430");
          // this.logServiceRequest('430', this.keyWord, response.data);
          if (!response.data.Result) {
            this.hasResults("430", false);
            this.addLoading("430");
            this.logServiceRequest("430", this.keyWord, {}, { Status: "900" });
            this.no_result++;
            this.loading--;
            // new Noty({
            //     theme: 'light',
            //     type: 'warning',
            //     text: this.$t('message.find_partner.data_is_not_found').replace('{x}', this.$t('message.find_partner.common_info_cn')).replace('{y}', this.keyWord),
            //     timeout: 5000,
            // }).show();
            return;
          }
          this.hasResults("430", true);
          var tmp_response_info = response.data.Result;

          this.tmp_company_info_for_helpers.EnglishName =
            response.data.Result.Name;
          this.tmp_company_info_for_helpers.Email = response.data.Result.Email;

          // transform change list data
          if (tmp_response_info.ChangeList.length > 0) {
            tmp_response_info.ChangeList.forEach((chg) => {
              if (typeof chg.BeforeList !== "string")
                chg.BeforeList = chg.BeforeList.join(",");
              if (typeof chg.AfterList !== "string")
                chg.AfterList = chg.AfterList.join(",");
            });
          }
          this.formatted_kw =
            this.keyWord + " | " + response.data.Result.EnglishName;
          var tmp_service_info = Object.entries(response.data.Result);

          tmp_service_info = tmp_service_info.filter(
            (item) =>
              typeof item[1] !== "object" && !_.isArray(item[1]) && item[1],
          );

          // Translating packages of text (columns of tables)
          var service_to_translate = [];
          tmp_service_info.forEach(([key, value]) => {
            service_to_translate.push(value);
          });

          this.getCompanyInfoTranslations(
            service_to_translate,
            tmp_service_info,
            tmp_response_info,
          ).then((r) => {
            this.addLoading("430");

            this.loading--;
            console.log("company 1");

            this.search_company_info_complete = true;
            this.company_info_data.response_info = tmp_response_info;
            this.pdf_document.company_info_data = this.company_info_data;

            this.logServiceRequest(
              "430",
              this.keyWord,
              this.company_info_data,
              response.data,
            );
          });
        })
        .catch(() => {
          this.hasResults("430", false);
          this.no_result++;
          this.loading--;
          this.addLoading("430");
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.find_partner.common_info_cn"),
              ) + this.keyWord,
            timeout: 5000,
          }).show();
        });
    },
    logServiceRequest(service_code, search_text, result, result_cn) {
      var requestlog = {};
      requestlog.service_code = service_code;
      requestlog.search_text = search_text;
      requestlog.result = result;
      this.global_log[service_code] = requestlog;
      this.global_log_cn[service_code] = result_cn;
      this.global_kw = search_text;

      // axios.post(window.base + '/contract/saveContrHistory', requestlog).then(ter => {

      // })
    },
    sendLog() {
      let requestlog = {};
      requestlog.service_code = Object.keys(this.global_log).join(",");
      requestlog.search_text =
        this.formatted_kw !== "" ? this.formatted_kw : this.global_kw;
      requestlog.result = JSON.stringify(this.global_log);
      let cn = {};
      cn.all_records = Object.keys(this.global_log_cn).length;
      Object.keys(this.global_log_cn).forEach((item, index) => {
        cn["service_code_" + index] = item;
        cn["search_text_" + index] = this.global_kw;
        cn["log_data_" + index] = this.global_log_cn[item];
      });
      requestlog.china_result = JSON.stringify(cn);
      axios
        .post(window.base + "/contract/saveContrHistory", requestlog)
        .then((response) => {
          this.history_record_id = response.data;
        })
        .catch(() => {
          this.history_record_id = 11;
        });
    },
    addLoading(service_code) {
      console.log("serv_code", service_code);
      console.log("servic", this.services_loading);
      var service = this.services_loading.find(
        (element) => parseInt(element.service) == parseInt(service_code),
      );
      console.log("serv", service);
      service.loading_step++;
      this.total_loaded++;
    },
    startTimer() {
      var sec = 0;
      this.interval = setInterval(() => {
        this.timer_seconds = this.pad(++sec % 60);
        this.timer_minutes = this.pad(parseInt(sec / 60, 10));
      }, 1000);
    },
    pad(val) {
      return val > 9 ? val : "0" + val;
    },
    noResultsLabel() {
      let services_array = [];
      this.services_loading.forEach((srvc) => {
        services_array.push(
          this.$t("message.find_partner.service_" + srvc.service),
        );
      });
      let keyWords = [];
      if (this.keyWord) keyWords.push(this.keyWord);
      if (this.keyWord886) keyWords.push(this.keyWord886);
      if (this.provinceCode) keyWords.push(this.provinceCode);
      if (this.cityCode) keyWords.push(this.cityCode);

      return this.$t("message.find_partner.no_results")
        .replace("[services]", services_array.join(","))
        .replace("[parameters]", keyWords.join(","));
    },
  },
  computed: {
    user_full_name() {
      return (
        this.$store.state.user.firstName + " " + this.$store.state.user.lastName
      );
    },
    is_bank() {
      return window.is_bank;
    },
    showKeyWord() {
      //console.log('checking');
      //console.log(this.services.length, this.services[0])
      if (this.services.length == 1 && this.services[0] == 886) return false;
      return true;
    },
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.doMount();
      },
    },
    keyWord() {
      window.is_searched = true;
    },
    keyWord886() {
      window.is_searched = true;
    },
    loading: function (newVal, oldVal) {
      if (oldVal > 0 && newVal <= 0) {
        clearInterval(this.interval);
        this.sendLog();
      }
    },
  },
};
</script>
<style>
.service-icon-holder {
  min-width: 100px;
  min-height: 100px;
  max-height: 100px;
  max-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2em;
  background: rgba(0, 123, 255, 0.3);
  border-radius: 4px;
  margin-right: 10px;
  position: relative;
}

.service-icon-holder span.api-id {
  font-size: 10px;
  display: block;
  position: absolute;
  bottom: 5px;
  left: 5px;
  right: 5px;
  text-align: center;
}

.service-text-holder {
  flex-basis: 100%;
}

.service-text-holder .service-title {
  font-weight: bold;
}

.service-text-holder .service-description {
  font-size: 13px;
}

.checkbox-holder {
  width: 30px;
  height: 100px;
  display: flex;
  justify-content: center;
}

.api-price {
  font-size: 10px;
  display: block;
  position: absolute;
  bottom: -20px;
  left: 5px;
  right: 5px;
  text-align: center;
}

.view-compact .service-icon-holder {
  min-width: calc(100% - 40px);
  max-width: calc(100% - 40px);
}

.service-block {
  flex-basis: calc(50% - 20px);
}

.service-block h4 {
  font-size: 18px;
}

.service-block p {
  /* height: 50px; */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.service-block p:hover {
  /* height: auto; */
  -webkit-line-clamp: 100;
  /* number of lines to show */
  line-clamp: 100;
}

.services-list {
  gap: 20px;
}
</style>
<style>
.modal-dialog.modal-sm.modal-dialog-centered .modal-body {
  font-size: 18px;
}

.modal-dialog.modal-sm.modal-dialog-centered .modal-footer .btn {
  font-size: 18px;
  padding: 10px 20px;
}

#keyWord886::placeholder {
  color: #ccc;
}

#sia_progress {
  width: 200px;
  height: 100px;
  margin: 20px auto;
  margin-bottom: 40px;
}
</style>

<style>
.hyperlink {
  cursor: pointer !important;
}

.dedede {
  display: flex;
  gap: 24px;
  position: relative;
}

.dedede .translator {
  flex-basis: 100%;
}

.dedede input {
  flex-basis: 100%;
  box-shadow:
    0px 12px 32px rgba(0, 0, 0, 0.04),
    0px 8px 24px rgba(0, 0, 0, 0.04),
    0px 2px 8px rgba(0, 0, 0, 0.04),
    0px 0px 1px rgba(0, 0, 0, 0.08);
  border-radius: 30px;
  padding: 14px 44px;
  border: 0;
}

.dedede .translator input::placeholder {
  color: #797980 !important;
}

.dedede button {
  padding: 14px 40px;
  background: linear-gradient(90deg, #259fe2 0%, #46b1e2 100%);
  border-radius: 30px;
  border: 0;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* primary100 */

  color: #ffffff;
}

.dedede .icon {
  left: 15px;
  position: absolute;
  z-index: 4;
}

.sia-row {
  padding: 5px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  display: flex;
  flex-wrap: nowrap;
}

.sia-row:first-child {
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}

.sia-row .title {
  display: block;
  flex-basis: 140px;
  min-width: 140px;
}

.sia-row .value {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
